/**
 * SubViewportContainer parser: Control layout plus the two properties that size and place the
 * displayed target. Defaults from `doc/classes/SubViewportContainer.xml`: `stretch = false`,
 * `stretch_shrink = 1`.
 */
import { boolOr, intOr } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
export function parseSubViewportContainer(heading, properties) {
    const base = parseControl(heading, properties);
    const context = `SubViewportContainer ${base.name || '(unnamed)'}`;
    return {
        ...base,
        stretch: boolOr(properties.stretch, false, context),
        stretch_shrink: intOr(properties.stretch_shrink, 1, context),
    };
}
//# sourceMappingURL=parser.js.map